import { render } from "./PagePdfColorSettings.vue?vue&type=template&id=46e5e95e&scoped=true"
import script from "./PagePdfColorSettings.vue?vue&type=script&lang=js"
export * from "./PagePdfColorSettings.vue?vue&type=script&lang=js"

import "./PagePdfColorSettings.vue?vue&type=style&index=0&id=46e5e95e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46e5e95e"

export default script